import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getSellersFn = ({ page, search }) => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.seller_list}?page=${page}&search=${search}`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const activeDeactiveSellerFn = (reqBody) => {
    try {
        const response = protectedApi.post(`${ENDPOINTS.seller_enable_disable}`, reqBody);
        return response;
    } catch (error) {
        throw error;
    }
}


export const UpdateSellerFn = (reqBody) => {
    try {
        const response = protectedApi.patch(`${ENDPOINTS.seller_list}`, reqBody);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getSellerByIdFn = (id) => {
    try {
        const response = protectedApi.get(`${ENDPOINTS.seller_list}?seller_id=${id}`);
        return response;
    } catch (error) {
        throw error;
    }
}



export const UpdateSellersFn = (reqBody) => {
    try {
        const response = protectedApi.patch(ENDPOINTS.seller_list, reqBody);
        return response;
    } catch (error) {
        throw error;
    }
}